<app-modal title="Your Order Summary">
  <section class="marTop40">
    @if (data.service) { @if (!crossSellAdded) {
    <div class="order-row">
      <div class="order-row-content weglot-allowed">
        <h2 class="greenT w400">{{ data.service.displayName }}</h2>
        <p class="darkGreyT tAlignLeft fs-1">{{ data.service.description }}</p>
      </div>
      <div class="order-row-price">
        <span class="order-total-label">Order Total:</span>
        @if (discountedTotal) {
        <span class="order-total-original">{{ combinedListedTotal | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
        } @else {
        <span class="order-total-value">{{ combinedTotal | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
        }
      </div>
    </div>
    @if (discountedTotal) {
    <div class="discount-bar-row">
      <div class="discount-bar-spacer"></div>
      <div class="discount-bar-standalone">
        {{ discountedTotal | currency : 'USD' : 'symbol' : '1.2-2' }}
      </div>
    </div>
    } @if (crossSellLink) {
    <div
      class="cross-sell-full marTop20"
      role="button"
      tabindex="0"
      (click)="addCrossSell()"
      (keydown.enter)="addCrossSell()"
      (keydown.space)="addCrossSell(); $event.preventDefault()"
    >
      <div class="cross-sell-icon-area clickable">
        <fa-icon [icon]="['far', 'cart-circle-plus']" class="cross-sell-cart-icon"></fa-icon>
        <span class="cross-sell-add-text">Add to Order</span>
      </div>
      <div class="cross-sell-details-area">
        <span class="cross-sell-name tAlignLeft"
          >{{ crossSellLink.service.displayName }} |
          {{ crossSellLink.service.totalPrice | currency : 'USD' : 'symbol' : '1.2-2' }}</span
        >
        @if (crossSellLink.crossSellDescription) {
        <p class="cross-sell-desc">{{ crossSellLink.crossSellDescription }}</p>
        }
      </div>
    </div>
    } } @if (crossSellAdded && crossSellLink) {
    <div class="order-grid">
      <div class="order-grid-cell order-grid-cell--service weglot-allowed">
        <h2 class="greenT w400">{{ data.service.displayName }}</h2>
        <p class="darkGreyT tAlignLeft fs-1">{{ data.service.description }}</p>
      </div>
      <div class="order-grid-cell order-grid-price">
        <span class="price-value">{{ data.service.totalPrice | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
      </div>

      <div class="order-grid-spacer"></div>
      <div class="order-grid-spacer"></div>

      <div class="order-grid-cell order-grid-cell--cross-sell">
        <div class="cross-sell-remove clickable" (click)="removeCrossSell()">
          <fa-icon [icon]="['far', 'times-circle']" class="cross-sell-remove-icon"></fa-icon>
        </div>
        <div class="cross-sell-added-block">
          <div class="cross-sell-added-bar"></div>
          <div class="cross-sell-added-info">
            <span class="cross-sell-name tAlignLeft">{{ crossSellLink.service.displayName }}</span>
            @if (crossSellLink.crossSellDescription) {
            <p class="cross-sell-desc">{{ crossSellLink.crossSellDescription }}</p>
            }
          </div>
        </div>
      </div>
      <div class="order-grid-cell order-grid-price order-grid-price--cross-sell">
        <span class="price-value">{{ crossSellLink.service.totalPrice | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
      </div>

      <div class="order-grid-cell"></div>
      <div class="order-grid-cell order-grid-price order-grid-price--total">
        <span class="order-total-label">Order Total:</span>
        @if (discountedTotal) {
        <span class="order-total-original">{{ combinedListedTotal | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
        } @else {
        <span class="order-total-value">{{ combinedTotal | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
        }
      </div>

      @if (discountedTotal) {
      <div class="order-grid-cell"></div>
      <div class="order-grid-cell order-grid-price order-grid-price--discount">
        <span class="discount-value">{{ discountedTotal | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
      </div>
      }
    </div>
    } } @else {
    <div class="dFlex alignItemsCenter">
      <div class="serviceDetails weglot-allowed">
        <h2 class="greenT w400">{{ tierSelected?.name }}</h2>
        @if (tierSelected?.tierLevel === 'essentials') {
        <ul class="darkGreyT tAlignLeft fs-1 marRight20">
          <li>100% satisfaction guarantee</li>
          <li>Included all required forms</li>
          <li>Option to print application at home</li>
          <li>Live chat support</li>
          <li>Comprehensive application review by immigration attorney</li>
          <li>Translation of required documents</li>
        </ul>
        } @if (tierSelected?.tierLevel === 'enhanced') {
        <ul class="darkGreyT tAlignLeft fs-1 marRight20">
          <li>Everything in Essentials</li>
          <li>Translation of 5 additional pages to include in your application (if needed)</li>
          <li>Ready-to-submit application mailed to your home</li>
          <li>Legal support if USCIS requests additional evidence</li>
          <li>Extended support from assigned Case Manager until approval</li>
          <li>One consultation with an immigration attorney to answer questions</li>
        </ul>
        } @if (tierSelected?.tierLevel === 'professional') {
        <ul class="darkGreyT tAlignLeft fs-1 marRight20">
          <li>Everything in Enhanced</li>
          <li>One consultation with an immigration attorney to discuss your application review</li>
          <li>One consultation with an immigration attorney to prepare you for your interview</li>
          <li>USCIS Interview Preparation Kit delivered to your door</li>
          <li>Two-day express shipping of your application</li>
        </ul>
        }
      </div>
      <div class="price marLeft20">
        <p class="darkGreyT tAlignLeft fs-1">
          Order Total: <span class="primaryT">{{ combinedTotal | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
        </p>
      </div>
    </div>
    }

    <hr class="marTop40 opat25" />

    @if (data.appCase) {
    <section class="marTop40 tAlignLeft">
      <p>
        Selected Case: {{ data.appCase.application?.name }} <small>({{ data.appCase.id }})</small>
      </p>
    </section>
    } @if (!data.appCase && data.cases) {
    <section class="marTop40">
      <label class="oneColumn tAlignLeft">
        <select
          [(ngModel)]="caseSelected"
          [required]="true"
          class="radius field darkWhiteBG50"
          [class.is-empty]="!caseSelected"
          (ngModelChange)="checkPriceAndLoadElements()"
        >
          @for (appCase of data.cases; track appCase) {
          <option [ngValue]="appCase">
            {{ appCase?.application?.applicationType?.name }}
          </option>
          }
        </select>
        <span class="darkGreyT"
          ><span>Select a Case <strong class="required">*</strong></span></span
        >
      </label>
    </section>
    } @if (data.appCase && data.tiers) {
    <section class="marTop40">
      <label class="oneColumn tAlignLeft">
        <select
          [(ngModel)]="tierSelected"
          [required]="true"
          class="radius field darkWhiteBG50"
          [class.is-empty]="!tierSelected"
          (ngModelChange)="checkPriceAndLoadElements()"
        >
          @for (tier of data.tiers; track tier) {
          <option [ngValue]="tier">{{ tier.tierLevel | titlecase }}</option>
          }
        </select>
        <span class="darkGreyT"
          ><span>Select an upgrade package: <strong class="required">*</strong></span></span
        >
      </label>
    </section>
    }

    <hr class="marTop40 opat25" />

    @if (!data.service) {
    <section class="marTop40 marBot40 tAlignLeft">
      <p class="marBot40">Provide your payment information</p>
      <div class="dFlex">
        <label class="flex1 marRight20">
          <input
            type="text"
            id="promoCode"
            name="promoCode"
            class="radius field darkWhiteBG50"
            [class.is-empty]="!promoCode"
            (keyup)="promoCodeFetched = false"
            (blur)="checkPromo()"
            [(ngModel)]="promoCode"
            [class.is-not-valid]="promoCode && promoCodeFetched && !promoCodeValid"
          />
          <span class="darkGreyT"><span>Promo code</span></span>
        </label>

        <button
          class="button primary radius dropShadow noMin normWeight noMarTop noMarRight noMarLeft"
          type="button"
          [disabled]="!promoCode && !promoCodeDescription"
          (click)="checkPromo()"
        >
          <fa-icon [icon]="['far', 'angle-double-left']"></fa-icon> Apply
        </button>
      </div>

      @if (promoCodeDescription) {
      <p class="promo found">
        <fa-icon class="greenT marRight20 fs-175" [icon]="['fas', 'circle-check']"></fa-icon>
        {{ promoCodeDescription }} applied.
      </p>
      } @if (promoCodeError) {
      <p class="promo notFound">
        <fa-icon class="marRight20 fs-175" [icon]="['fas', 'octagon-xmark']"></fa-icon>
        {{ promoCodeError }}
      </p>
      }
    </section>
    } @if (data.service) {
    <section class="marTop40 marBot40 tAlignLeft">
      <h6 class="paymentTitle locked relative marBot10 darkGreyT w300 tAlignCenter">Secure Payment Information</h6>
    </section>
    } @else { @if (combinedTotal !== '0.00') {
    <section class="marBot10 tAlignLeft">
      <h6 class="paymentTitle locked relative darkGreyT w300 tAlignCenter">
        Secure Credit Card Payment Information
        <span class="dBlock"><span>This is a secure 256-bit SSL encrypted payment.</span></span>
      </h6>
    </section>
    } }

    <form id="payment-form" class="overflowXHidden">
      @if (combinedTotal !== '0.00') {
      <div id="payment-element">
        <!--Stripe.js injects the Payment Element-->
      </div>
      } @if (data.service) {
      <div class="promo-code-section marTop20">
        @if (!showPromoInput) {
        <button class="promo-code-toggle" type="button" (click)="showPromoInput = true">
          Add Promo Code <fa-icon [icon]="['fas', 'tag']" class="promo-tag-icon"></fa-icon>
        </button>
        } @else {
        <div class="promo-code-input-row">
          <div class="promo-code-field">
            <label class="promo-code-label-text" for="servicePromoCode">Promo Code</label>
            <input
              type="text"
              id="servicePromoCode"
              class="promo-code-input"
              [(ngModel)]="promoCode"
              [ngModelOptions]="{ standalone: true }"
              (keyup)="promoCodeFetched = false"
              (keyup.enter)="checkPromo()"
              (blur)="checkPromo()"
            />
          </div>
          @if (promoCodeDescription) {
          <div class="promo-banner promo-banner--success">
            <fa-icon class="promo-banner-icon" [icon]="['fas', 'circle-check']"></fa-icon>
            <span>{{ promoCodeDescription }}</span>
          </div>
          } @else if (promoCodeError) {
          <div class="promo-banner promo-banner--error">
            <fa-icon class="promo-banner-icon" [icon]="['fas', 'octagon-xmark']"></fa-icon>
            <span>{{ promoCodeError }}</span>
          </div>
          }
        </div>
        }
      </div>
      } @if (combinedTotal !== '0.00') {
      <p class="marTop40 fs-875 tAlignLeft">
        By providing your card information, you allow SimpleCitizen, Inc. to charge your card for future payments in
        accordance with their terms.
      </p>
      }
      <div class="marTop40 fs-875 tAlignLeft">
        <input type="checkbox" id="stripe-terms" [formControl]="terms" />
        <label for="stripe-terms"
          >I agree to the
          <a
            class="w700 clickable underlineHover"
            href="https://www.simplecitizen.com/terms-and-conditions/"
            target="_blank"
            >SimpleCitizen Terms and Conditions of Use</a
          ></label
        >
      </div>

      <div id="payment-message" class="hidden"></div>
    </form>

    @if (checkPriceError) {
    <p class="promo notFound">
      <fa-icon class="marRight20 fs-175" [icon]="['fas', 'octagon-xmark']"></fa-icon>
      {{ checkPriceError }}
    </p>
    } @if (paymentError) {
    <p class="notFound">
      <fa-icon class="marRight20 fs-175" [icon]="['fas', 'octagon-xmark']"></fa-icon>
      {{ paymentError }}
    </p>
    } @if (paymentSuccessful) {
    <p class="found">
      <fa-icon class="greenT marRight20 fs-175" [icon]="['fas', 'circle-check']"></fa-icon>
      Payment successful.
    </p>
    }

    <div class="actionBtnContainer">
      <button
        class="actionBtn w400 marTop20"
        type="button"
        (click)="submitPayment($event)"
        [disabled]="paymentButtonDisabled"
      >
        Complete Purchase
      </button>
    </div>
  </section>
</app-modal>
